import axios from "axios";
// import store from "@coach/js/store/store";
// import Csrf from "@client/services/Csrf";

let Api = axios.create({
  baseURL: "/coach/api",
  withCredentials: true
});

Api.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
  Api.defaults.headers.common["X-CSRF-TOKEN"] = token.content;
} else {
  console.error("CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token");
}

let apiToken = document.head.querySelector('meta[name="api-token"]');
if (apiToken) {
  Api.defaults.headers.common["Authorization"] =
    "Bearer " + apiToken.content;
} else {
  console.warn("API token not found");
}

/*
 * Add a request interceptor
 * It will automatically add the CSRF token to all requests
 */
// Api.interceptors.request.use(async req => {
//   if (req.url != Csrf.url) {
//     await Csrf.getCookie();
//   }
//   return req;
// });

/*
 * Add a response interceptor
 * It will log out of the app if any API requests return 'unauthenticated'
 */
// Api.interceptors.response.use(
//   response => response,
//   error => {
//     if (
//       store.getters["auth/loggedIn"] &&
//       (error.response.status === 401 || error.response.status === 419)
//     ) {
//       store.dispatch("auth/logout");
//     }
//     return Promise.reject(error.response);
//   }
// );

export default Api;
